import {useDispatch, useSelector} from "react-redux";
import {Row, Col, Card} from 'antd';
import TickerChip from "../../Components/TickerChip";
import {useEnsureTickersLoaded} from "../../Hooks/useEnsureTickersLoaded";



const getSymbolsList = (tickerGroup)=>{
    return Array.isArray(tickerGroup) ? tickerGroup : Object.keys(tickerGroup);
}

const TickerDisplay = () => {
    const tickerGroup = useSelector(state => state.appStates.tickerGroup);
    const { tickers } = useEnsureTickersLoaded(tickerGroup);


    return (
        <Row wrap={true}>
            {tickers.map((ticker, index) => (
                <Col key={index} span={6}>
                    <Card>
                        <TickerChip ticker={ticker} />
                    </Card>
                </Col>
            )
            )}
        </Row>
    )


}
export default TickerDisplay;